function FileUploadCtrl(url, $http, $mdToast, $mdDialog, $rootScope, Upload) {
    "ngInject";

    var main = this;
    main.uploading = false;

    main.uploadFile = function(file) {
        main.uploading = true;
        Upload.upload({
            'url': url,
            'data': {'file': file},
            'method': 'PUT'
        }).then(
            function() {
                main.uploading = false;
                $mdDialog.hide();
            },
            function() {
                main.uploading = false;
            },
            function(e) {
                console.log(e);
            }
        );

    };
}

angular.module('app').controller('FileUploadCtrl', FileUploadCtrl);
